export const red = {
  25: '#1C1920',
  50: '#281C23',
  100: '#3F2328',
  150: '#56292E',
  200: '#6D2F33',
  300: '#9A3C3F',
  400: '#C8484A',
  500: '#F65555',
  600: '#F87777',
  700: '#FA9999',
  800: '#FBBBBB',
  900: '#FDDDDD',
  950: '#FEEEEE',
  975: '#FFF6F6',
  990: '#FFFCFC',
} as const;
